<template>
  <div>
    <div class="top_box2">
      <div>
        <div class="top_list" >
          <div :class="tarIndex === index ?'tar_info blue':'tar_info'" v-for="(item,index) in tarList" :key="index" @click="select(index)">
            {{item}}
          </div>
        </div>
        <div class="jianjie">
          <div class="text">
            公司简介
          </div>
        </div>
        <div class="jianjie_info">
          <div class="jianjiewenzi">
            <div>湖南岳泰兴医疗科技有限公司是一家专注于大健康领域的“专精特新”企业。公司集研发、生产、销售和服务于一体，致力于为医疗机构、家庭及个人提供高品质的医疗信息化系统、医疗设备、健康产品及解决方案。</div>
            <div>岳泰兴医疗拥有智慧医院、智慧养老、康复器械、智能医疗设备、家用医疗产品等产品体系，覆盖医院、诊所及家庭健康场景，数智化布局线上线下。</div>
            <div>岳泰兴医疗科技秉承“用科技服务人类健康”的理念，推动大健康事业的发展。紧跟国家“互联网+医疗健康”政策，持续推动技术创新和产品升级，为打造成中国领先、国际知名的世界品牌而阔步前进！成为大健康行业佼佼者！</div>
          </div>
         <div class="video"> <video src="/newIndex/video/1.mp4" controls></video></div>

        </div>
      </div>
    </div>
    <div class="brandConcept" ref="brandConcept">
      <div class="brandConceptInfo">
        <div class="text">
          公司理念
        </div>
        <div class="brandConcept_bottom">
          <div class="brandConceptInfo_left">
            <div class="left_info">
              <div class="left_info_text">企业愿景：</div>
              <div class="left_info_title">成为大健康行业佼佼者</div>
            </div>

            <div class="left_info">
              <div class="left_info_text">企业使命：</div>
              <div class="left_info_title">推动医疗数字化转型与创新打造普惠高效优质医疗服务</div>
            </div>
            <div class="left_info">
              <div class="left_info_text">企业价值观：</div>
              <div class="left_info_title">以人为本、心怀感恩 用户至上、追求卓越</div>
            </div>
            <div class="left_info">
              <div class="left_info_text">企业文化：</div>
              <div class="left_info_title">在追求全体员工物质和精神两方面幸福的同时，为全人类健康作出贡献</div>
            </div>
            <div class="left_info">
              <div class="left_info_text">企业精神：</div>
              <div class="left_info_title">诚信、专业、创新、责任</div>
            </div>

          </div>
          <img src="/status/jianjie.webp">
        </div>
      </div>

    </div>
    <div class="brandConcept2" ref="brandConcept2">
      <div class="text">
        荣誉资质
      </div>
      <div class="border_"></div>
      <img src="/status/ppninian.webp">
    </div>
    <tail_menu></tail_menu>
  </div>
</template>

<script>
import tail_menu from "@/components/tail_menu_phone";
export default {
  name: "brandConcept",
  components:{
    tail_menu,
  },
  data(){
    return{
      tarIndex:0,
      tarList:[
        '公司简介',
          '公司理念',
          '荣誉资质'
      ]
    }
  },
  methods:{
    select(index){
      this.tarIndex = index
      if(this.tarIndex == 1){
        this.$refs.brandConcept.scrollIntoView({ behavior: 'smooth' });
      }
      if(this.tarIndex == 2){
        this.$refs.brandConcept2.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.top_list{
  display: flex;
  border-bottom: 1px solid rgb(216,216,216);
  width: 1400px;
  .tar_info{
    padding: 0 50px 45px;
    cursor: pointer;
    font-weight: bold;
    font-size: 62px;
  }
  .blue{

    border-bottom: 1px solid #4a7bac;
    color: #4a7bac;
  }
}
.top_box2{
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 50px 0;
  .jianjie{
    margin-top: 50px;
  }
  .jianjie_info{
    margin-top: 50px;
    .video{
      margin-top: 40px;
      width: 1400px;
      height: 700px;
      background: black;
      display: flex;
      align-items: center;
      video{
        width: 1400px;
        height: 700px;
      }
    }

    .jianjiewenzi{
      width: 1400px;
      line-height: 54px;
      font-size: 48px;
      color: #555555;
      div{
        margin-bottom: 10px;
        text-indent: 4ch;
      }
    }
  }
  .text{
    font-size: 60px;
    font-weight: 600;
  }
}
.brandConcept{
  background-color: #F3F3F3;
  display: flex;
  justify-content: center;
  .brandConceptInfo{
    width: 1400px;
    padding: 50px 0;
    .text{
      font-size: 62px;
      font-weight: 600;
      margin-bottom: 60px;
    }
    .brandConcept_bottom{
      .brandConceptInfo_left{
        .left_info{
          display: flex;
          margin-top: 40px;
          .left_info_text{
            font-size: 50px;
            font-weight: bold;
            color: #555555;
          }
          .left_info_title{
            width: 1100px;
            color: #555555;
            font-size: 52px;
            line-height: 60px;
          }
        }
      }
      img{
        width: 1400px;
        height: 800px;
        border-radius: 10px;
        margin-top: 30px;
      }
    }


  }
}
.brandConcept2{
  background: white;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 50px 0 0 0;
  .text{
    font-size: 74px;
    font-weight: 600;
    color: #003b76;
  }
  .border_{
    margin-top: 30px;
    width: 150px;
    border: 2px solid #327ecb;
  }
  img{
    margin-top: 20px;
    width: 100%;
    height: 900px;
  }
}
</style>
